<template>
    <div class="wrap-lg">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px 0">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item >服务项目</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card>
        <el-row :gutter="20">
          <el-col :span="18"  class="reach-html">
            <div class="ads" v-html="strHtml"></div>
          </el-col>
          <el-col :span="6">
            <ad-right></ad-right>
          </el-col>
        </el-row>
      </el-card>
    </div>
</template>

<script>
import { getLists } from '@/api/ads/adsTexts'
export default {
  name: 'index',
  data () {
    return {
      strHtml: '',
      param: {
        categoryCode: 'service_project'
      }
    }
  },
  mounted () {
    this.getInfo()
  },
  methods: {
    toPage (path) {
      this.$router.push({
        name: path
      })
    },
    getInfo () {
      getLists(this.param).then(res => {
        var result = res.data
        if (result.rtnCode === '0') {
          if (result.bizData && result.bizData.length > 0) {
            this.strHtml = result.bizData[0].content
          }
        } else {
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.$message.error('加载失败')
      })
    }
  }
}
</script>

<style scoped>
  table
  {
    border-collapse: collapse;
    text-align: center;
    width: 90%;
  }
  table td, table th
  {
    border: 1px solid #cad9ea;
    color: #666;
    height: 30px;
    padding: 10px;
  }
  table thead th
  {
    background-color: #CCE8EB;
    width: 100px;
  }
  table tr:nth-child(odd)
  {
    background: #fff;
  }
  table tr:nth-child(even)
  {
    background: #F5FAFA;
  }

</style>
